import {InjectionToken} from '@angular/core';

export const AEM_CONFIGURATION = new InjectionToken<AemOptions>('AEM_CONFIGURATION');

export interface AemOptions {
  host?: string;
}
